import {
  Button,
  ConfirmationBox,
  ModalLayout,
  OffCanvasLayout,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React, { useRef } from "react";
import Address from "../Verification/Address";
import Items from "../Verification/Items";
import Services from "../Verification/Services";
import Style from "../verifications.module.scss";
import Filter from "./Filter";
import OrderCardListing from "../../Global/OrderCardListing";
import useVerificationReassign from "./useVerificationReassign";
import FilterButton from "../../Global/FilterButton";
import ApprovedDetails from "./ApprovedDetails";
import OfficeSlip from "../Verification/OfficeSlip/OfficeSlip";
import StockReceipt from "../Verification/StockReceipt/StockReceipt";

const certBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  padding: "4px 8px",
  borderRadius: "15px",
  backgroundColor: "var(--pro-primary)",
  color: "#fff",
  fontSize: "12px",
};

const certRemoveBtnStyle = {
  background: "transparent",
  paddingLeft: "8px",
  border: "none",
  color: "#ffffff",
  cursor: "pointer",
  fontSize: "14px",
  lineHeight: "1",
};

const VerificationReassign = () => {
  const {
    state,
    states,
    filterShow,
    filterCount,
    showDetail,
    showApproved,
    selectedApprovedItem,
    activeCard,
    isLoading,
    totalLength,
    apiStatus,
    certModalShow,
    certInput,
    setCertInput,
    enteredCertificates,
    requiredCertCount,
    handleLoadMore,
    handleSearchInput,
    setIsLoading,
    handleSearch,
    handleChange,
    setFilterShow,
    handleReject,
    handleRejectRequest,
    handleOpenCertModal,
    handleCloseCertModal,
    handleAddCertificate,
    handleRemoveCertificate,
    handleSubmitCertificates,
  } = useVerificationReassign();

  const officeSlipRef = useRef(null);
  const StockReceiptRef = useRef(null);

  return (
    <>
      <div className="row pro-mb-4 gx-2">
        <div className="col-auto">
          <SearchFilters
            showDateRange={false}
            onSearchInput={handleSearchInput}
            showFilters={true}
            showActions={false}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            searchInputProps={{
              placeholder: "Search GLI Number",
              onKeyDown: (e) => e.key === "Enter" && handleSearch(),
            }}
          />
        </div>
        <div className={`col-auto`}>
          <button
            className="pro-btn pro-btn-primary"
            onClick={handleSearch}
            type="button"
          >
            <span className="material-symbols-outlined">search</span>
            Search
          </button>
        </div>
        <div className="col">
          <FilterButton
            onClick={() => setFilterShow(true)}
            filterCount={filterCount}
            className={Style.filter_btn}
          />
        </div>
      </div>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div
            className={`col-xxl-4 col-5 cards-wrapper ${Style.card_main_wrapper}`}
          >
            <div
              className={`pro-d-flex cards-grid-wrap ${Style.card_flow_wrap}`}
            >
              <OrderCardListing
                isLoading={isLoading}
                activeCard={activeCard}
                data={states}
                totalLength={totalLength}
                extaClassName={Style.Verification_list}
                handleChange={handleChange}
                setIsLoading={setIsLoading}
                refBottom
                handleLoadMore={handleLoadMore}
                apiStatus={apiStatus}
              />
            </div>
          </div>
          {showDetail === true ? (
            <div className={`col pro-pe-0 ${Style.table_main_wrapper}`}>
              <div className={`${Style.table_flow_wrapper} pro-pe-3`}>
                <div className={`row gx-3 ${Style.multicolumn_wrapper}`}>
                  <div className="col-xxl-6">
                    <Address state={state} />
                  </div>
                  <div className="col-xxl-6">
                    <Services state={state} />
                  </div>
                </div>
                <div
                  className={`row gx-3 ${Style.multicolumn_wrapper} pro-mb-4`}
                >
                  <div className="col-12">
                    <Items state={state} />
                  </div>
                </div>
                <div
                  className={`col-12 pro-d-flex pro-justify-end pro-py-3 pro-pe-5 ${Style.footer_btn_wrap}`}
                >
                  <Button
                    className={"pro-btn-primary lg pro-ms-3"}
                    type="button"
                    onClick={handleOpenCertModal}
                  >
                    Approve
                  </Button>
                </div>
              </div>
            </div>
          ) : showApproved === true ? (
            <div className={`col ${Style.table_main_wrapper}`}>
              <div className={`${Style.table_flow_wrapper}`}>
                <ApprovedDetails
                  key={selectedApprovedItem?._id}
                  receiptId={selectedApprovedItem?._id}
                  gliNumber={selectedApprovedItem?.gli_number}
                  officeSlipRef={officeSlipRef}
                  StockReceiptRef={StockReceiptRef}
                />
              </div>
            </div>
          ) : null}
        </div>
        <OffCanvasLayout
          centered={true}
          show={filterShow}
          handleClose={() => {
            setFilterShow(false);
          }}
          title={"Filter"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <Filter setShowform={setFilterShow} />
        </OffCanvasLayout>
        <ModalLayout show={certModalShow} handleClose={handleCloseCertModal}>
          <div className="pro-m-4">
            <h6 className="pro-ttl pro-mb-2">Enter Certificate Numbers</h6>
            <p className="pro-font-sm pro-mb-3">
              {enteredCertificates?.length} / {requiredCertCount} entered
            </p>
            <div className="input-wrap pro-mb-3">
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                Certificate Number
              </label>
              <input
                type="text"
                className="pro-input lg"
                value={certInput}
                onChange={(e) => setCertInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddCertificate()}
                placeholder="Enter certificate number"
              />
            </div>
            <Button
              className={"pro-btn-primary lg pro-mb-3"}
              type="button"
              onClick={handleAddCertificate}
              disabled={enteredCertificates?.length >= requiredCertCount}
            >
              Add Certificate
            </Button>
            {enteredCertificates?.length ? (
              <div className="pro-d-flex pro-flex-wrap pro-gap-2 pro-mb-4">
                {enteredCertificates?.map((cert, index) => (
                  <span
                    key={cert}
                    className="pro-badge badge-primary"
                    style={certBadgeStyle}
                  >
                    {cert}
                    <button
                      type="button"
                      onClick={() => handleRemoveCertificate(index)}
                      style={certRemoveBtnStyle}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            ) : null}
            <div className="pro-d-flex pro-justify-end">
              <Button
                className={"pro-btn-link lg pro-px-5"}
                type="button"
                onClick={handleCloseCertModal}
              >
                Cancel
              </Button>
              <Button
                className={"pro-btn-primary lg pro-ms-3"}
                type="button"
                onClick={handleSubmitCertificates}
                disabled={enteredCertificates?.length !== requiredCertCount}
              >
                Submit
              </Button>
            </div>
          </div>
        </ModalLayout>
        <ModalLayout show={state?.rejectModal} handleClose={handleReject}>
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure you want to reject?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleReject}
              submitText={"Yes"}
              submitAction={handleRejectRequest}
              isRight={true}
            />
          </div>
        </ModalLayout>
      </div>
      <div className={Style.print}>
        <OfficeSlip officeSlipRef={officeSlipRef} />
        <StockReceipt stockPrintRef={StockReceiptRef} />
      </div>
    </>
  );
};

export default VerificationReassign;
